"use client";

import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react";

import styles from "./courses.module.scss";
import Components from "@/components";
import useApi from "@/hooks/useApi";
import sk from "@/skeletons";
import api from "@/api";
import "./swiper.css";

const filterList = [
  { key: 0, value: "Popular" },
  { key: 1, value: "Latest" },
  { key: 2, value: "For You" },
];

function Recommended({ gap, vidPerView }) {
  const user = useSelector((state) => state?.user?.users);
  const [recommended, setRecommended] = useState([]);
  const [filter, setFilter] = useState(filterList[0]);

  const { data: filterCourse, request: loadFilterCourse } = useApi(
    api.getfilteredcourse
  );

  useEffect(() => {
    loadFilterCourse(filter.value);
  }, [user, filter]);

  useEffect(() => {
    setRecommended(filterCourse);
  }, [filterCourse]);

  return (
    <section className={styles["hm-category-rows"]}>
      <header className={styles["hm-category-header"]}>
        <div className={styles["title"]}>
          <h1>Recommended Courses</h1>
        </div>
        <Components.Filter
          list={filterList}
          filter={filter}
          handleChange={setFilter}
        />
      </header>
      <article
        className={`${styles["hm-category-videos"]} ${
          !recommended?.data?.length ? styles["loading"] : ""
        }`}
      >
        <button
          className={`${styles["slider-nav-button"]} ${styles["prev"]}`}
          id="CP_Recommended_Course_Left_Btn"
        >
          <Icon icon={"mdi:keyboard-arrow-left"} />
        </button>
        {recommended?.data?.length ? (
          <Swiper
            slidesPerView={vidPerView}
            spaceBetween={gap}
            freeMode={true}
            pagination={false}
            modules={[FreeMode, Navigation]}
            navigation={{
              prevEl: "#CP_Recommended_Course_Left_Btn",
              nextEl: "#CP_Recommended_Course_Right_Btn",
            }}
            className={styles["latestvideo-swiper"]}
          >
            <div>
              <SwiperSlide>
                <Components.Languify active="0" />
              </SwiperSlide>
              {recommended.data?.map((course, i) => (
                <SwiperSlide key={i}>
                  <Components.CourseCard
                    type="course"
                    id={course?._id}
                    seoTitle={course?.seoTitle}
                    videoTitle={course?.firstVideoTitle}
                    visibility={course?.visibility}
                    image={course?.thumbnailImage}
                    tag={course?.categories}
                    enrollCount={course?.enrolled_count}
                    title={course?.title}
                    videoCount={course?.videosCount}
                    timeCount={course?.totalTime}
                    creatorInfo={{
                      id: course?.creatorInfo?.[0]?._id,
                      name: course?.creatorInfo?.[0]?.name,
                      username: course?.creatorInfo?.[0]?.username,
                      image: course?.creatorInfo?.[0]?.profileImage,
                    }}
                  />
                </SwiperSlide>
              ))}
            </div>
          </Swiper>
        ) : (
          <sk.RowCardSkeleton number={Math.ceil(vidPerView)} />
        )}
        <button
          className={`${styles["slider-nav-button"]} ${styles["next"]}`}
          id="CP_Recommended_Course_Right_Btn"
        >
          <Icon icon="mdi:keyboard-arrow-right" />
        </button>
      </article>
    </section>
  );
}

export default Components.CardWrapper(Recommended);
